// extracted by mini-css-extract-plugin
module.exports = {"banner-root":"Banner_banner-root__2EzbR"};